import { Spin } from 'antd';
import type { FC } from 'react';

interface Props {
  delay?: number;
}

export const PageLoader: FC<Props> = ({ delay = 0 }) => {
  return <Spin size="large" fullscreen description="Loading" delay={delay} />;
};
